import gql from "graphql-tag";
import { Query } from "react-apollo";
import { compose, graphql, ApolloProvider } from "react-apollo"; //apollo-client

import fetch from "node-fetch";
import reactStringReplace from "react-string-replace";
import CONTEXT from "./graphqlapi";
import client from "../../common/Apolloconfig/index";

const QUERY_getschoolincitydata = gql`
  query getschoolincity($cityname: String) {
    getschoolincity(cityname: $cityname) {
      id
      CDSCode
      County
      District
      School
      StreetAbr
      City
      State
      PhoneNumber
      Website
      GSserved
      Boundary
      SchoolLat
      SchoolLong
      NumberofStudents
      StudentRatio
      GreatSchoolsRating
      AcademicProgressCollegeReadiness
      TestScores
      EquityReview
      latlangs
      greatschoolurl
    }
  }
`;

async function getschoolincity(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getschoolincitydata,
        options: {
          fetch: fetch,
        },
        variables: {
          cityname: getdata.cityname,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export { getschoolincity };
